import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICod0101mState, ICodeGroup, IInquiryCndsState } from '../../models/cod/cod0101m_model';

const initialState: ICod0101mState = {
    inquiryCnds: {
        instCd: '',
        empNo: '',
        codeGroupNm: '',
    },
    cdGrpList: [],
    selectedCdGrpRowKeys: [],
};

export const cod0101m_Slice = createSlice({
    name: 'cod0101m_Slice',
    initialState,
    reducers: {
        initState: () => initialState,
        setInquiryCnds: (state, action: PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setCdGrpList: (state, action: PayloadAction<ICodeGroup[]>) => {
            state.cdGrpList = action.payload;
        },
        addCdGrpItem: (state, action: PayloadAction<ICodeGroup>) => {
            state.cdGrpList.push(action.payload);
        },
        removeCdGrpItemsByIndexes: (state, action: PayloadAction<number[]>) => {
            state.cdGrpList = state.cdGrpList.filter(
                (_, idx) => !action.payload.includes(idx)
            );
        },
        updateCdGrpItem: (state, action: PayloadAction<{ idx: number; data: ICodeGroup }>) => {
            state.cdGrpList[action.payload.idx] = action.payload.data;
        },
        setSelectedCdGrpRowKeys: (state, action: PayloadAction<number[]>) => {
            state.selectedCdGrpRowKeys = action.payload;
        },
    },
});

export default cod0101m_Slice.reducer;
export const Cod0101mAction = cod0101m_Slice.actions;
export const Cod0101mReducer = cod0101m_Slice.reducer;
